import React from "react";
import { motion } from "framer-motion";
import { TIMELINE } from "@/data/content";

const item = {
  hidden: { opacity: 0, y: 50 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};

export default function CareerTimeline() {
  return (
    <section id="journey" className="relative py-24 md:py-32 bg-[#0a0a0a]" data-testid="journey-section">
      <div className="container mx-auto px-6 md:px-12">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={item}
          className="flex items-center gap-3 mb-4"
        >
          <span className="font-mono text-xs tracking-[0.25em] uppercase text-volt">02 / Journey</span>
          <span className="h-px flex-1 bg-neutral-800" />
        </motion.div>

        <motion.h2
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={item}
          className="font-heading uppercase text-5xl sm:text-6xl lg:text-7xl leading-none tracking-tight text-white mb-16"
        >
          The Touchline<span className="text-volt"> Journey</span>
        </motion.h2>

        <div className="relative">
          {/* vertical line */}
          <div className="absolute left-0 md:left-[220px] top-0 bottom-0 w-px bg-neutral-800" />

          <div className="flex flex-col gap-12">
            {TIMELINE.map((entry, idx) => (
              <motion.div
                key={idx}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-60px" }}
                variants={item}
                className="relative pl-8 md:pl-0 md:grid md:grid-cols-[220px_1fr] md:gap-10"
                data-testid={`timeline-entry-${idx}`}
              >
                {/* Year */}
                <div className="md:text-right md:pr-10">
                  <span className="font-mono text-sm text-volt tracking-widest">{entry.year}</span>
                </div>

                {/* Node */}
                <span className="absolute left-[-5px] md:left-[216px] top-1.5 h-2.5 w-2.5 rounded-full bg-volt shadow-[0_0_16px_2px_rgba(229,255,0,0.6)]" />

                {/* Content */}
                <div className="pb-2">
                  <h3 className="font-heading uppercase text-2xl sm:text-3xl text-white leading-tight">
                    {entry.role}
                  </h3>
                  <p className="font-mono text-xs uppercase tracking-wide text-neutral-400 mt-2">
                    {entry.org}
                  </p>
                  <ul className="mt-4 space-y-2">
                    {entry.points.map((pt, i) => (
                      <li key={i} className="flex gap-3 font-body font-light text-sm md:text-base text-neutral-300">
                        <span className="text-volt mt-1.5 h-1 w-1 rounded-full bg-volt shrink-0" />
                        <span>{pt}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
